<div class="px-2" *ngIf="!isOpened">
  <app-custom-table [showExport]="true" [showRecover]="true" [headers]="generalHeader" [data]="generalData"
    [previousFilters]="filters" [filterPersistentKey]="'workshop-equipment'"
    (onRecoverData)="getWorkshopEquipmentWithPagination()" (onPageChange)="onPageChange($event)"
    (onFilterChange)="onFilterChange($event)" (onExport)="exportGeneralConsultation()">
  </app-custom-table>
</div>

<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>